module.exports = __webpack_public_path__ + "media/images/front/timeline/about_us_5-127a5fc54de9b4a778edda21d496662b.webp";